const getMasterOutput = (video: Video) =>
  video.outputs.find((output) => output.isMaster);

export default getMasterOutput;
